import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Key, Settings, Building } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">H</span>
              </div>
              <span className="text-xl font-semibold">Les Hirondelles</span>
            </div>
            <p className="text-primary-foreground/80 mb-4 max-w-md">
              Coopérative de location de vélos sur la côte atlantique française. 
              La mobilité douce, facilitée avec simplicité et authenticité.
            </p>
            <p className="text-sm text-primary-foreground/60">
              Une approche humaine de la mobilité, ancrée dans le territoire.
            </p>
          </div>

          {/* Navigation rapide */}
          <div>
            <h3 className="font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/particuliers" className="text-primary-foreground/80 hover:text-white transition-smooth">
                  Particuliers
                </Link>
              </li>
              <li>
                <Link to="/professionnels" className="text-primary-foreground/80 hover:text-white transition-smooth">
                  Professionnels
                </Link>
              </li>
              <li>
                <Link to="/velos-occasion" className="text-primary-foreground/80 hover:text-white transition-smooth">
                  Vélos d'occasion
                </Link>
              </li>
              <li>
                <Link to="/qui-sommes-nous" className="text-primary-foreground/80 hover:text-white transition-smooth">
                  Qui sommes-nous
                </Link>
              </li>
              <li>
                <Link to="/espace-partenaires" className="text-primary-foreground/60 hover:text-primary-foreground/80 transition-smooth text-sm">
                  Espace partenaires
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="text-primary-foreground/60 hover:text-primary-foreground/80 transition-smooth text-sm">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Button asChild variant="outline" size="sm" className="bg-primary-foreground/10 border-primary-foreground/20 text-primary-foreground/80 hover:bg-primary-foreground/20 hover:text-white text-xs px-3 py-1 h-auto">
                  <Link to="/acces-professionnel" className="flex items-center">
                    <Key className="h-3 w-3 mr-1" />
                    Accès professionnel
                  </Link>
                </Button>
              </li>
              <li>
                <Button asChild variant="outline" size="sm" className="bg-primary-foreground/10 border-primary-foreground/20 text-primary-foreground/80 hover:bg-primary-foreground/20 hover:text-white text-xs px-3 py-1 h-auto">
                  <Link to="/equipe" className="flex items-center">
                    <Settings className="h-3 w-3 mr-1" />
                    Espace équipe
                  </Link>
                </Button>
              </li>
              <li>
                <Button asChild variant="outline" size="sm" className="bg-primary-foreground/10 border-primary-foreground/20 text-primary-foreground/80 hover:bg-primary-foreground/20 hover:text-white text-xs px-3 py-1 h-auto">
                  <Link to="/partenaires" className="flex items-center">
                    <Building className="h-3 w-3 mr-1" />
                    Portail partenaires
                  </Link>
                </Button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">Contact</h3>
            <div className="space-y-2 text-sm text-primary-foreground/80">
              <p>30 rue Gambetta, 17590 Ars-en-Ré, France</p>
              <p>laudare.iledere@gmail.com</p>
              <p>07 66 47 77 46</p>
              <p className="text-xs text-primary-foreground/60 mt-2">Disponible tous les jours de 9h à 19h</p>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-8 pt-8 text-center">
          <p className="text-sm text-primary-foreground/60">
            © 2026 SARL LAUDARE - Les Hirondelles. Tous droits réservés.
          </p>
          <div className="mt-2 flex justify-center gap-4">
            <Link 
              to="/admin" 
              className="text-xs text-primary-foreground/40 hover:text-primary-foreground/60 transition-colors"
            >
              Admin Portal 2.0
            </Link>
            <span className="text-xs text-primary-foreground/20">|</span>
            <Link 
              to="/admin-demandes" 
              className="text-xs text-primary-foreground/40 hover:text-primary-foreground/60 transition-colors"
            >
              Admin Legacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;